import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const FramedContentContainer = ({
  classes,
  t,
  title,
  children,
  allowOverflow,
  disableMinHeight,
  isMandatory,
  childContainerStyles,
  showBorder,
  contianerStyles
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.framedContentContainer} 
                ${disableMinHeight && classes.noMinHeight} ${showBorder ? classes.border : ""} ${contianerStyles}`
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subTitleText,
    component: "div"
  }, t(title), " ", isMandatory && /*#__PURE__*/React.createElement("div", {
    className: classes.mandatory
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: `${classes.childContainer} 
                                    ${allowOverflow && classes.childOverflow} 
                                    ${disableMinHeight && classes.noMinHeight} 
                                    ${childContainerStyles}`
  }, children));
};
const styles = theme => ({
  framedContentContainer: {
    backgroundColor: theme.background.default,
    minHeight: 140,
    maxHeight: 240,
    padding: 16
  },
  border: {
    border: theme.palette.border
  },
  disablePaddingTop: {
    paddingTop: 5
  },
  subTitleText: {
    color: theme.palette.primary.main
  },
  childContainer: {
    width: 600,
    minHeight: 100,
    maxHeight: 220,
    backgroundColor: theme.palette.background.paper,
    overflowY: "auto"
  },
  childOverflow: {
    overflowY: "unset"
  },
  noMinHeight: {
    minHeight: 0
  },
  mandatory: {
    color: theme.palette.error.main,
    display: "inline"
  }
});
export default withStyles(styles)(withi18n(FramedContentContainer));
FramedContentContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disablePaddingTop: PropTypes.bool,
  allowOverflow: PropTypes.bool,
  disableMinHeight: PropTypes.bool,
  isMandatory: PropTypes.bool,
  childContainerStyles: PropTypes.string,
  showBorder: PropTypes.bool,
  contianerStyles: PropTypes.string
};
FramedContentContainer.defaultProps = {
  disablePaddingTop: false,
  allowOverflow: false,
  disableMinHeight: false,
  isMandatory: false,
  showBorder: false
};